/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Booking_Cutoff_HintInputs */

const en_admin_resource_form_booking_cutoff_hint = /** @type {(inputs: Admin_Resource_Form_Booking_Cutoff_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many hours in advance must a booking be made?`)
};

const de_admin_resource_form_booking_cutoff_hint = /** @type {(inputs: Admin_Resource_Form_Booking_Cutoff_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Buchung kann bis zu dieser Anzahl von Stunden vor ihrem Beginn vorgenommen werden`)
};

const es_admin_resource_form_booking_cutoff_hint = /** @type {(inputs: Admin_Resource_Form_Booking_Cutoff_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una reserva puede ser realizada hasta este número de horas antes de su inicio`)
};

const fr_admin_resource_form_booking_cutoff_hint = /** @type {(inputs: Admin_Resource_Form_Booking_Cutoff_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une réservation peut être effectuée jusqu'à autant d'heures avant son début`)
};

/** @type {(inputs: Admin_Resource_Form_Booking_Cutoff_HintInputs) => LocalizedString} */
const it_admin_resource_form_booking_cutoff_hint = en_admin_resource_form_booking_cutoff_hint;

/** @type {(inputs: Admin_Resource_Form_Booking_Cutoff_HintInputs) => LocalizedString} */
const pt_br2_admin_resource_form_booking_cutoff_hint = en_admin_resource_form_booking_cutoff_hint;

/** @type {(inputs: Admin_Resource_Form_Booking_Cutoff_HintInputs) => LocalizedString} */
const pl_admin_resource_form_booking_cutoff_hint = en_admin_resource_form_booking_cutoff_hint;

/** @type {(inputs: Admin_Resource_Form_Booking_Cutoff_HintInputs) => LocalizedString} */
const hu_admin_resource_form_booking_cutoff_hint = en_admin_resource_form_booking_cutoff_hint;

/** @type {(inputs: Admin_Resource_Form_Booking_Cutoff_HintInputs) => LocalizedString} */
const ro_admin_resource_form_booking_cutoff_hint = en_admin_resource_form_booking_cutoff_hint;

/**
* | output |
* | --- |
* | "How many hours in advance must a booking be made?" |
*
* @param {Admin_Resource_Form_Booking_Cutoff_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_booking_cutoff_hint = /** @type {((inputs?: Admin_Resource_Form_Booking_Cutoff_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Booking_Cutoff_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_booking_cutoff_hint(inputs)
	if (locale === "de") return de_admin_resource_form_booking_cutoff_hint(inputs)
	if (locale === "es") return es_admin_resource_form_booking_cutoff_hint(inputs)
	if (locale === "fr") return fr_admin_resource_form_booking_cutoff_hint(inputs)
	if (locale === "it") return it_admin_resource_form_booking_cutoff_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_booking_cutoff_hint(inputs)
	if (locale === "pl") return pl_admin_resource_form_booking_cutoff_hint(inputs)
	if (locale === "hu") return hu_admin_resource_form_booking_cutoff_hint(inputs)
	return ro_admin_resource_form_booking_cutoff_hint(inputs)
});
export { admin_resource_form_booking_cutoff_hint as "admin.resource_form.booking_cutoff_hint" }